module.exports = __webpack_public_path__ + "img/card_tag.01566cd1.png";